export default {
    type: 'person-news',
    aliases: {
        camel: 'personNews',
        singular: 'Person news',
        plural: 'Person news',
        lowerSingular: 'person news',
        lowerPlural: 'person news',
    },
    publishable: false,
    adminSection: null,
    componentType: 'pivot',
    components: {}
};
